import React from 'react';
import { path } from 'ramda';
import { InternalStandardProps, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';
import { useEditContextForInput } from '../useEditContextForInput';
import { Omit } from '../../../crud-core/utils/TypescriptUtils';

export type TextInputProps = {
  field: string;
  label?: string;
  item?: Object;
  showLabel?: boolean;
  onChange?: (field: string, value: Object) => void;
  textFieldProps?: TextFieldProps;
} & Omit<InternalStandardProps<React.HTMLAttributes<HTMLDivElement>>, 'onChange'>;

const TextInput: React.FC<TextInputProps> = ({
  className,
  field,
  showLabel = true,
  label,
  style,
  textFieldProps,
  onChange,
  item,
}: TextInputProps) => {
  // If we provide an onChange function it prevails from using context
  let value: string | undefined;
  let props: TextFieldProps;
  if (onChange) {
    value = path(field.split('.'), item) || '';
    props = {
      onChange: (event) => onChange(field, event.target.value),
    };
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { fieldValue, onChange: onInputChange } = useEditContextForInput<string>(field);
    value = fieldValue || '';
    props = {
      onChange: (event) => onInputChange(event.target.value || null),
    };
  }

  return (
    <TextField
      className={className}
      inputProps={{ 'data-testid': `text-input-${field}` }}
      label={showLabel ? label || field : ''}
      margin="normal"
      value={value}
      variant="standard"
      style={style}
      {...props}
      {...textFieldProps}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default TextInput;
